import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=4e71cdbb&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=4e71cdbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e71cdbb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterResultsColumnHeader: require('/usr/src/motec/components/FilterResults/ColumnHeader.vue').default,FilterResultsMobileColumnHeader: require('/usr/src/motec/components/FilterResults/MobileColumnHeader.vue').default,FilterResultsRow: require('/usr/src/motec/components/FilterResults/Row.vue').default,FilterResultsMobileRow: require('/usr/src/motec/components/FilterResults/MobileRow.vue').default})
